// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundEnrollmentWorkflowModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentWorkflowModel.attributeTypeMap;
    }
}
CoverMyMedsInboundEnrollmentWorkflowModel.discriminator = undefined;
CoverMyMedsInboundEnrollmentWorkflowModel.additionalProperties = false;
CoverMyMedsInboundEnrollmentWorkflowModel.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
];
//# sourceMappingURL=coverMyMedsInboundEnrollmentWorkflowModel.js.map